import { createStore } from 'vuex'
import createPersistedState from 'vuex-persistedstate'
import user from './user'
import search from './search'
import cart from './cart'
import general from './general'
import consent from './consent'
import loopCookieBanner from './cookie-banner'

export default createStore({
  plugins: [createPersistedState()],
  modules: {
    consent,
    loopCookieBanner,
    user,
    search,
    cart,
    general,
  },
})
